import SelectComponent from "@via/components/select/select";
import { isSelectOption, type SelectOption } from "@via/utils/interfaces";
import { useActiveTags } from "@via/api/entity-tags.api.tsx";
import { TaggableEntityType } from "common";
import { useMemo } from "react";

interface TagValueInputProps {
  entityType: TaggableEntityType;
  value: string;
  onChange: (value: string) => void;
}

export default function TagValueInput({
  entityType,
  value,
  onChange,
}: TagValueInputProps) {
  const { data: tagsData, isLoading } = useActiveTags(entityType);

  const tagOptions: SelectOption[] = useMemo(() => {
    if (!tagsData?.data) return [];
    return tagsData.data.map(tag => ({
      label: tag.name,
      value: tag.id,
    }));
  }, [tagsData]);

  return (
    <SelectComponent
      name="tagValueInput"
      options={tagOptions}
      value={
        value ? (tagOptions.find(opt => opt.value === value) ?? null) : null
      }
      onChange={selected => {
        if (isSelectOption(selected)) {
          onChange(selected.value as string);
        }
      }}
      placeholder={isLoading ? "Loading..." : "Select tag"}
      isSearchable={true}
      isLoading={isLoading}
    />
  );
}
